"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M6.81 16h.38l.6-6H6.21z",
  opacity: ".3"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "M9.22 7c.48-.53.78-1.23.78-2 0-1.66-1.34-3-3-3S4 3.34 4 5c0 .77.3 1.47.78 2z"
}, "1"), /*#__PURE__*/_jsx("path", {
  d: "M16 2c-2.21 0-4 1.79-4 4v12c0 1.1-.9 2-2 2s-2-.9-2-2h1l1-10H4l1 10h1c0 2.21 1.79 4 4 4s4-1.79 4-4V6c0-1.1.9-2 2-2s2 .9 2 2v16h2V6c0-2.21-1.79-4-4-4M7.19 16h-.38l-.6-6h1.58z"
}, "2")], 'MicExternalOnTwoTone');